
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent11 as ObiWindApparent11Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-11.js';
 
 
 

 
 export const ObiWindApparent11 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-11',
   elementClass: ObiWindApparent11Element,
   events: {
     
   }
  });
 
 